import * as React from "react";
import {
    Container,
    Breadcrumb,
    BreadcrumbItem,
    Button, Row, Col
} from 'reactstrap';
import {WithTranslation, withTranslation} from 'react-i18next';
import {connect} from "react-redux";
import {ApplicationState} from "App/store";
import {
    getSelectedMainCategoryData,
    getSelectedProductData,
    getSelectedSubCategoryData
} from "App/services";
import {
    selectCategoryPageAction,
    selectConfigurePageAction,
    selectMainPageAction, selectContractPageAction, selectOfferPageAction,
    selectSubCategoryPageAction, selectSpecialOfferPageAction
} from "App/routes";
import {
    ProductFamilyIconsInner,
    Product,
    UsedMainCategoriesInner
} from "App/services/api";
import {UserState} from "App/user";
import {startLogin} from "App/services/reducers/auth";
import {isLoginDisabled, selectedLang} from "App/helper";
import {LoginModule} from "Containers/LoginModule";
import {ActionType, Language} from "App/constants";
import {Payload} from "redux-first-router";
import {toggleFilter} from "App/services/reducers/products";

interface StateToProps {
    pageType: string | null
    payload: Payload | null
    categoryData: UsedMainCategoriesInner | null
    subcategoryData: ProductFamilyIconsInner |null
    productData: Product |null
    showFilterIcon: boolean
    showFilterActive: boolean
}

interface ComponentStateToProps extends StateToProps {
    user: UserState | null
}

interface DispatchToProps {
    onClick: (action:any) => void
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    pageType: state.location? state.location.type:null,
    payload: state.location? state.location.payload:null,
    categoryData: getSelectedMainCategoryData(state.data),
    subcategoryData: getSelectedSubCategoryData(state.data),
    productData: getSelectedProductData(state.data),
    showFilterIcon: state.data.products&&state.data.products.filters.size>0||false,
    showFilterActive: state.data.products&&!state.data.products.showFilters||false
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onClick: (action) => dispatch(action)
});

class _ConfiguratorHeader extends React.Component<DispatchToProps & ComponentStateToProps & WithTranslation> {

    constructor(props: any, context: any) {
        super(props, context);
    }

    render() {
        const { t, i18n, categoryData, subcategoryData, productData, onClick, pageType, payload, user, showFilterIcon, showFilterActive } = this.props;
        const language: Language = selectedLang(i18n);
        return (
            <React.Fragment>
                <div className="configurator py-4">
                    <Container className="px-0">
                        <div className="row justify-content-between no-gutters">
                            <div className="pl-3 pl-sm-0 flex-grow-1 header header">{t('header.title')}</div>
                            <div className="header">
                                {!isLoginDisabled() && (pageType === ActionType.PAGE_CONTRACT || pageType === ActionType.PAGE_OFFER || pageType === ActionType.PAGE_CONFIGURATION)?
                                    <Button className="other login text-uppercase text-right px-0" onClick={() => onClick(startLogin())}>
                                        <i className="far fa-user-circle pr-2 fa-lg"></i>{ user?t('products.configuration.user', user):t('products.configuration.login') }
                                    </Button>:
                                    null
                                }
                            </div>
                        </div>
                    </Container>
                </div>
                <div className="pathway">
                    <Container className="pl-3 pl-sm-0 pr-0 py-0">
                        <Row className={"no-gutters"}>
                            <Col className={"col-10"}>
                                <Breadcrumb tag="nav">
                                    <BreadcrumbItem tag="span" onClick={() => onClick(selectMainPageAction())}>{t('menu.maincategories')}</BreadcrumbItem>
                                    {pageType === ActionType.PAGE_CONTRACT ?
                                        <BreadcrumbItem tag="span" onClick={() => onClick(selectContractPageAction())}>{t('menu.contract')}</BreadcrumbItem> :
                                        (pageType === ActionType.PAGE_OFFER ?
                                            <BreadcrumbItem tag="span" onClick={() => onClick(selectOfferPageAction())}>{t('menu.offer')}</BreadcrumbItem> :
                                            (pageType === ActionType.PAGE_SPECIALOFFER ?
                                                <BreadcrumbItem tag="span" onClick={() => onClick(selectSpecialOfferPageAction( payload&&payload['sogId']))}>{t('menu.specialoffers')}</BreadcrumbItem> :
                                                <React.Fragment>
                                                    {categoryData ? <BreadcrumbItem tag="span" onClick={() => onClick(selectCategoryPageAction(categoryData.id))}>{categoryData.nameml[language]}</BreadcrumbItem> : null}
                                                    {categoryData && subcategoryData ? <BreadcrumbItem tag="span" onClick={() => onClick(selectSubCategoryPageAction(categoryData.id, subcategoryData.id))}>{subcategoryData.nameml[language]}</BreadcrumbItem> : null}
                                                    {categoryData && subcategoryData && productData ? <BreadcrumbItem tag="span" onClick={() => onClick(selectConfigurePageAction(categoryData.id, subcategoryData.id, productData.id))}>{t('menu.configure', {name: productData.nameml[language]})}</BreadcrumbItem> : null}
                                                </React.Fragment>))
                                    }
                                </Breadcrumb>
                            </Col>
                            <Col className={"col-2 d-flex justify-content-center flex-column pr-5"}>
                                {categoryData && subcategoryData && !productData && showFilterIcon?
                                    <i className={"action fa fa-filter align-self-end fa-lg" + (showFilterActive?"":" disabled")} aria-hidden="true" onClick={() => showFilterActive&&onClick(toggleFilter())}></i> : null
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
                <LoginModule user={user}/>
            </React.Fragment>
        );
    }
}

export const ConfiguratorHeader = connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(_ConfiguratorHeader));


// WEBPACK FOOTER //
// ./src/fragments/ConfiguratorHeader.tsx